




















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Tree as TreeSort, TreeItem } from "@/plugins/tree";
import { Draggable, Tree } from "he-tree-vue";
import { LearningUnit as ILearningUnit } from "@/api-v2/course/models/learning-unit";
import { Registration as IRegistration } from "@/api-v2/course/models/registration";
import { LearningProgress as ILearningProgress } from "@/api-v2/course/models/learning-progress";
import { LearningUnitProgressSessionStatusEnum as UnitStatus } from "@/api-v2/course/models/learning-unit-progress-session";
import { courseApi } from "@/getinfo-api";

@Component({
  components: {
    Tree: Tree.mixPlugins([Draggable])
  }
})
export default class LearningUnitTree extends Vue {
  @Prop() learningUnits!: ILearningUnit[];
  @Prop() courseId!: string;
  @Prop() registration?: IRegistration;
  courseLecturesTree: Array<TreeItem<any>> = [];
  progress?: ILearningProgress;

  data() {
    return {
      progress: undefined
    };
  }

  get progressUnits() {
    return this.registration?.course?.learningUnits.map(el => {
      return {
        detailUnitInfo: el,
        sessions: this.progress?.learningUnits?.find(_ => _.iri === el.iri)
          ?.sessions,
        id: el.id
      };
    });
  }

  getStatus(id: string) {
    const getResult = (value: number): string => {
      return value === 1 ? "fas fa-check" : "fas fa-check green-icon";
    };

    const findUnit = this.progressUnits?.find(_ => _.id === id);
    let isHasSession = findUnit?.sessions?.length;
    let isHasPassedSessions = findUnit?.sessions?.some(
      _ =>
        _.status === UnitStatus.CompletedAndPassed ||
        _.status === UnitStatus.Passed ||
        _.status === UnitStatus.Completed
    );
    let isHasSessionResult = isHasSession ? 1 : 0;
    let isHasPassedSessionsResult = isHasPassedSessions ? 1 : 0;
    const result = isHasSessionResult + isHasPassedSessionsResult;

    return result ? getResult(result) : "''";
  }

  initTree() {
    const options = this.learningUnits.map(el => {
      return {
        id: el.id,
        parentId: el.parentId || null,
        entity: el
      };
    });

    const tree = new TreeSort(options);

    this.courseLecturesTree = tree.getTreeItems();
  }

  @Watch("learningUnits")
  upd() {
    this.initTree();
  }

  @Watch("registration")
  async getProgress() {
    if (this.registration) {
      try {
        const {
          data
        } = await courseApi.LearningProgress.getLearningProgress(
          this.registration.id,
          ["sessions"]
        );

        this.progress = data;
      } catch (e) {
        throw new Error(e);
      }
    }
  }

  created() {
    if (this.learningUnits.length) {
      this.initTree();
      this.getProgress();
    }
  }
}
